import { usePricing } from '../contexts/PricingContext'
import { getGuaranteedHires } from '../utils/guarantee'
import { useFinancialModel } from './useFinancialModel'

/** Live guaranteed hire count, from the same model the proposal shows. */
export function useGuaranteedHires(): number {
  const { cpaHigh } = usePricing()
  const model = useFinancialModel()
  return getGuaranteedHires(model, cpaHigh)
}
